/* eslint-disable import/no-default-export */
import {
  createPortal,
  render,
  unmountComponentAtNode,
} from './src/react-dom-wrapper';

export {
  createPortal,
  render,
  unmountComponentAtNode,
} from './src/react-dom-wrapper';

/** @deprecated Please use `renderReactRoot` */
export default {
  /** @deprecated Please use `renderReactRoot` */
  render,
  /** @deprecated */
  unmountComponentAtNode,
  /** @deprecated */
  createPortal,
};
